module.exports = __webpack_public_path__ + "static/media/CH.f0617e6d.svg";